import React, { useState, useEffect } from 'react';

const UploadDocument = ({ type, setFile, file, isOpen, setIsOpen, showDescription = true }) => {
    const [error, setError] = useState(null);
    const [title, setTitle] = useState('');
    const [subtitle, setSubtitle] = useState('');

    useEffect(() => {
        switch (type) {
            case 'edicto':
                setTitle('Edicto de la subasta');
                setSubtitle('Un edicto es un anuncio oficial publicado en el BOE (Boletín Oficial del Estado) para informar sobre la celebración de una subasta pública. En él se detallan aspectos clave como el objeto de la subasta, las condiciones para participar y los plazos establecidos. Es un documento fundamental para garantizar la transparencia y el acceso público al proceso.');
                break;
            case 'nota-simple':
                setTitle('Nota simple/Certificación de cargas');
                setSubtitle('Puede solicitarse en el registro de la propiedad y proporciona información detallada sobre la situación legal de los bienes objeto de la subasta. Incluye datos como titularidad, posibles cargas o gravámenes, y cualquier anotación que pueda afectar al valor o disponibilidad del bien subastado. Es una herramienta indispensable para los interesados en participar en la subasta con pleno conocimiento de la situación jurídica del bien');
                break;
            default:
                setTitle('Documento');
        }
    }, [type]);

    const handleFile = (newFile) => {
        if (newFile) {
            if (newFile.type === 'application/pdf') {
                setFile(newFile);
                setError(null);
            } else {
                console.log("El archivo no es un PDF.");
                setError("El archivo no es un PDF.");
            }
        }
    };

    const handleChange = (event) => {
        handleFile(event.target.files[0]);
        event.target.value = '';
    };

    const handleDrop = (event) => {
        event.preventDefault();
        handleFile(event.dataTransfer.files[0]);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    return (
        <div className="flex flex-col w-full">
            {showDescription && (
                <div id="accordion-collapse" data-accordion="collapse">
                    <h2 id={`accordion-collapse-heading-${type}`}>
                        <button
                            type="button"
                            className="flex items-center justify-between w-full p-5 font-medium text-gray-500 border border-b-0 border-gray-200 rounded-t-xl dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
                            data-accordion-target={`#accordion-collapse-body-${type}`}
                            aria-expanded={isOpen}
                            aria-controls={`accordion-collapse-body-${type}`}
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span>{title}</span>
                            <i className={`fas fa-${isOpen ? 'chevron-up' : 'circle-info'}`}></i>
                        </button>
                    </h2>
                    <div
                        id={`accordion-collapse-body-${type}`}
                        className={`${isOpen ? '' : 'hidden'}`}
                        aria-labelledby={`accordion-collapse-heading-${type}`}
                    >
                        <div className="p-5 border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900">
                            <p className="mb-2 text-gray-500 dark:text-gray-400">{subtitle}</p>
                        </div>
                    </div>
                </div>
            )}
            {!file && (
                <div
                    className="flex"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                >
                    <div className="relative flex-grow flex items-center">
                        <label
                            htmlFor={`dropzone-file-${type}`}
                            className={`${showDescription ? 'rounded-b-xl' : 'rounded-xl'} flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed cursor-pointer bg-blueGray-50 dark:hover:bg-blueGray-100 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600`}
                        >
                            <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                <i className="fas fa-cloud-arrow-up text-4xl text-gray-400 dark:text-gray-500"></i>
                                <p className="mb-2 text-base text-gray-500 dark:text-gray-400">
                                    <span className="font-semibold">Click para seleccionar</span> o suelta aquí
                                </p>
                            </div>
                            <input
                                id={`dropzone-file-${type}`}
                                type="file"
                                className="hidden"
                                accept="application/pdf"
                                onChange={handleChange}
                            />
                        </label>
                    </div>
                </div>
            )}
            {file &&
                <div className="flex flex-col items-center justify-center pt-5 pb-6 border border-b-0 border-gray-200 rounded-b-xl">
                    <i className="fas fa-circle-check text-4xl text-emerald-500"></i>
                    <p className="my-2 text-base text-gray-500 dark:text-gray-400">
                        {file.name}
                    </p>
                </div>
            }
            {error && <p className="text-red-500 text-center">{error}</p>}
        </div>
    );
};

export default UploadDocument;